module.exports = __webpack_public_path__ + "img/iconMenu.6023fa58.svg";